import { WorkflowSnippetFn } from '../types';

export const text: WorkflowSnippetFn = (props) => `
curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/workflows/${props.workflowId}/results" \
    -H "Authorization: Key ${props.pat}" \
    -H "Content-Type: application/json" \
    -d '{
      "inputs": [
        {
          "data": {
            "text": {
              "url": "${props.inputUrl}"
            }
          }
        }
      ]
    }'
   
`;

export const image: WorkflowSnippetFn = (props) => `
curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/workflows/${props.workflowId}/results" \
  -H "Authorization: Key ${props.pat}" \
  -H "Content-Type: application/json" \
  -d '{
    "inputs": [
        {
          "data": {
            "image": {
              "url": "${props.inputUrl}"
          }
        }
      }
    ]
}'
`;

export const audio: WorkflowSnippetFn = (props) => `
curl -X POST "${props.apiHost}/v2/users/${props.userId}/apps/${props.appId}/workflows/${props.workflowId}/results" \
  -H "authorization: Key ${props.pat}" \
  -H "content-type: application/json" \
  -d '{
    "inputs": [
        {
          "data": {
            "audio": {
              "url": "${props.inputUrl}"
          }
        }
      }
    ]
}'
`;
